import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../../theme/palette';

const style = () =>
  createStyles({
    suiviQuizContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    suiviQuizRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      alignItems: 'center'
    },
    red: {
      color: palette.common.primaryRed
    },
    green: {
      color: palette.common.green
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
